import { render, staticRenderFns } from "./WorkgroupOrderReport.vue?vue&type=template&id=4de7ea20"
import script from "./WorkgroupOrderReport.vue?vue&type=script&lang=js"
export * from "./WorkgroupOrderReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports